export const getTarget = (link) => {
  const anchorIdRegex = /#(?:[a-zA-Z0-9_-]+)+/;
  const isHomeDepotLink = link.includes('homedepot.com');

  return (anchorIdRegex.test(link) || isHomeDepotLink) ? '_self' : '_blank';
};
